import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        alignItems: 'center',
        rowGap: '5px',
        paddingRight: '50px',
        alignContent: 'flex-start',
    },
    textInput: {
        marginTop: '4px',
        marginLeft: '10px',
        height: '30px',
        width: '100%',
        padding: '0px',
    },
    inputOptionButton: {
        justifyContent: 'end',
        height: '30px',
        width: '85px',
        textTransform: 'capitalize',
        fontSize: '12px',
        padding: '0px 5px 0px 5px',
    },
});
